import Stage1Player4Room from "../shared/Stage1Player4Room";

export default function Six_Players_Stage1_Player4(props) {
  return <Stage1Player4Room {...props} playerCount={6} hasDrawerRapatriated={false} />;
}